<template>
  <hic-dialog :title="title" v-loading="meta.loading" :visible="visible" @close="cancel" width="70rem" top="10vh">
    <el-main style="padding: 5px 20px">
      <el-row v-if="!entity.id" type="flex" justify="center">
        <el-input size="small" class="right-pad" @keyup.enter.native="getPatient" v-model="condition.keyword" placeholder="姓名、住院号、病案号、证件号码" v-loading="meta.searching" style="width: 20rem" clearable>
          <el-button slot="append" type="info" icon="el-icon-search" @click.native="getPatient"></el-button>
        </el-input>
      </el-row>

      <div v-else>
        <el-row>
          <el-row type="flex" justify="space-between" class="ztitle">
            基本信息
            <el-button size="small" type="warning" class="left-pad" icon="el-icon-sort" @click="switchPatient">切换患者</el-button>
          </el-row>
          <el-descriptions :column="3">
            <el-descriptions-item label="姓名">{{ entity.patientName }}</el-descriptions-item>

            <el-descriptions-item label="性别">{{ entity.patientGender | dictText('Gender') }}</el-descriptions-item>

            <el-descriptions-item label="住院科室">{{ entity.deptCode | dictText('Dept') }}</el-descriptions-item>

            <el-descriptions-item label="床位号">{{ entity.patientAge }}</el-descriptions-item>
            <el-descriptions-item label="住院号">{{ entity.ipNo }}</el-descriptions-item>

            <el-descriptions-item label="主要诊断">{{ entity.diagnosisName }}</el-descriptions-item>
          </el-descriptions>
        </el-row>

        <el-collapse :value="['手术信息', '审核信息']">
          <el-collapse-item title="手术信息" name="手术信息">
            <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="6rem">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="手术编码" prop="code">
                    <el-input type="text" maxlength="6" v-model="detailValue.code" placeholder="请输入手术编码" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术名称" prop="name">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术名称" prop="">
                    <el-date-picker size="small" v-model="detailValue.appDate" type="date" placeholder="请选择预约时间："></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="术前诊断" prop="">
                    <el-input type="text" maxlength="6" style="width: 100%" v-model="detailValue.a" placeholder="请输入手术诊断" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术室" prop="">
                    <hic-dict-selector dict-type="Dept"></hic-dict-selector>
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术类别" prop="">
                    <hic-dict-selector dict-type=""></hic-dict-selector>
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="麻醉方式" prop="">
                    <hic-dict-selector dict-type=""></hic-dict-selector>
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="切口愈合等级" prop="">
                    <hic-dict-selector dict-type="HealingCourse"></hic-dict-selector>
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术级别" prop="">
                    <hic-dict-selector dict-type="SurgeryGrade"></hic-dict-selector>
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="手术部位" prop="">
                    <!-- <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" /> -->
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="主刀医生" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="第一助手" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="第二助手" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="第三助手" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="16">
                  <el-form-item label="第四助手" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="HBsAg" prop="">
                    <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="抗-HCV" prop="">
                    <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="抗-HIV" prop="">
                    <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="梅毒" prop="">
                    <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="血型" prop="">
                    <dict-select v-model="detailValue.cardType" dict-type="IdType" class="edit-select" />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="备注" prop="">
                    <el-input type="text" maxlength="6" v-model="detailValue.name" placeholder="请输入手术名称" size="small" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <el-collapse-item title="审核信息" name="审核信息">
            <span class="left-pad">已拒绝: 麻醉方式填写不详。 2022-08-17 11:02</span>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-main>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="$emit('update:visible', false)" class="left-pad">提交</el-button>
    </template>
  </hic-dialog>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  components: {},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      detailValue: {},
      condition: {
        keyword: '',
      },
      rules: {},
      meta: {
        loading: false,
      },
    };
  },
  computed: {},
  filters: {},
  watch: {},
  mounted() {},
  methods: {
    getPatient() {
      if (!this.condition.keyword.replace(/(^\s*)|(\s*$)/g, '')) {
        return this.$message.error('请输入信息查询');
      }
      this.meta.loading = true;
      api.hospitalization
        .query(this.condition)
        .then(res => {
          if (!res.items.length) {
            return this.$message.warning('暂无患者信息');
          }
          this.entity = res.items[0];
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.meta.loading = false;
          this.$message.info('手术信息字段待调整补充');
        });
    },
    switchPatient() {
      this.entity = {};
      this.condition.keyword = '';
    },
    cancel() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.ztitle,
/deep/ .el-collapse-item__header {
  color: #66b1ff;
  font-size: 17px;
}
</style>
